import React from 'react';
import { useAuth } from '../context/AuthContext';
import '../styles/theme.css';

const Header = ({ title, actions }) => {
  const { user } = useAuth();

  return (
    <div className="bg-white rounded-3xl shadow-sm p-6 mb-6">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-3xl font-bold text-gray-900">{title}</h1>
          <p className="text-gray-600 mt-1">Welcome back, {user?.name || 'User'}!</p>
        </div>
        {actions && (
          <div className="flex space-x-4">
            {actions}
          </div>
        )}
      </div>
    </div>
  );
};

export default Header;
